import { LoginStatuses, TwoFactorTypes } from 'mmfintech-backend-api'
import type { ChallengeDetails } from 'mmfintech-backend-api/types'
import { tr } from 'mmfintech-commons'

export const prepareOtpTitle = (challenge: ChallengeDetails, userStatus: string) => {
  // const { twoFactorType } = challenge?. || {}

  switch (challenge?.twoFactorType) {
    case TwoFactorTypes.SMART_ID:
      return tr('FRONTEND.VERIFY_OTP.SMART_ID.TITLE', "Verify it's you")

    case TwoFactorTypes.SMS:
      return userStatus === LoginStatuses.LOGGED_IN
        ? tr('FRONTEND.VERIFY_OTP.TITLE_VERIFY_SMS', 'SMS verification')
        : tr('FRONTEND.VERIFY_OTP.TITLE_SMS', 'SMS confirmation')

    case TwoFactorTypes.TOTP:
      return userStatus === LoginStatuses.LOGGED_IN
        ? tr('FRONTEND.VERIFY_OTP.TITLE_VERIFY_TOTP', 'Google Authenticator verification')
        : tr('FRONTEND.VERIFY_OTP.TITLE_TOTP', 'Google Authenticator confirmation')

    default:
      return userStatus === LoginStatuses.LOGGED_IN || userStatus === LoginStatuses.SECOND_FACTOR
        ? tr('FRONTEND.VERIFY_OTP.TITLE_VERIFY_EMAIL', 'Email verification')
        : tr('FRONTEND.VERIFY_OTP.TITLE_EMAIL', 'Email confirmation')
  }
}
